import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import cancelPolicyPagesRoleManagement from '../../staticRoleManagement/cancelPolicyRoleManagement'
import CancelPoliciesList from '../CancelPoliciesList'
import ModifyPoliciesList from '../ModifyPoliciesList'
import useStyles from './styles/index.styles'

export default function PoliciesTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()

  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      value: 'cancel-policies',
      className: classes.tab,
      label: getTranslate('Cancel Policies'),
      component: LocalizedLink,
      to: '/policies/cancel-policies'
    },
    {
      value: 'amendment-policies',
      className: classes.tab,
      label: getTranslate('Amendment Policies'),
      component: LocalizedLink,
      to: '/policies/amendment-policies'
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = cancelPolicyPagesRoleManagement.find(
    (item) => item.route === '/policies/(cancel-policies|amendment-policies)'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((tabItem) => (
            <Tab
              key={tabItem.value}
              value={tabItem.value}
              className={tabItem.className}
              label={tabItem.label}
              to={tabItem.to}
              component={LocalizedLink}
            />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="cancel-policies"
        dir={theme.direction}
        className={classes.tabPanel}>
        <CancelPoliciesList />
      </TabPanel>
      <TabPanel
        value={page}
        index="amendment-policies"
        dir={theme.direction}
        className={classes.tabPanel}>
        <ModifyPoliciesList />
      </TabPanel>
    </div>
  )
}
